import {useClientContext} from "../contexts/ClientContext"
import useAccountInitializer from "../hooks/useAccountInitializer"
import {WCService} from "../flow/config"
import {modalType} from "./Modal"
import {DECLINE_RESPONSE} from "../constants"
import {ClipboardDocumentIcon} from "@heroicons/react/24/outline"
import faucetIcon from "../assets/images/faucet_icon.svg"
import {useState} from "react"

export default function WalletConnection(props) {

    const [copied, setCopied] = useState(false)

    const {
        connect,
        currentUser,
        isAccountInitialized,
        isAccountInitStateLoading,
        checkIsAccountInitialized,
        setShowModal,
        setModalData,
        flowBalance,
        unityUnloading
    } = useClientContext()

    const isConnected = !!currentUser?.loggedIn

    const doConnect = () => {
        // force wallet connect
        connect({service: WCService})
    }

    const [state, initializeAccount] = useAccountInitializer(
        () => {
            checkIsAccountInitialized()
            setShowModal(false)
        },
        (err) => {
            if (err === DECLINE_RESPONSE) {
                setModalData({
                    type: modalType.Error,
                    title: "Transaction Declined",
                    message: "Oops, it looks like you chose to decline this transaction."
                })
            } else {
                setModalData({type: modalType.Error, title: "Error", message: err})
            }
            setShowModal(true)
        }
    )

    const doInitialize = async () => {
        initializeAccount()
    }

    const doCopy = () => {
        navigator.clipboard.writeText(currentUser?.addr);
        setCopied(true)
        setTimeout(() => {
            setCopied(false)
        }, 5000)
    }

    return (
        <div className={"relative flex mb-8"}>
            <div className={'flex flex-col items-center'}>
                {!isConnected  && <div className={'flex flex-col max-w-xl items-center'}>
                    <button onClick={doConnect}
                            className={"font-pinwy text-3xl uppercase flex px-4 py-2 my-2 border-4 border-gray-700 hover:border-white rounded-md text-white bg-fr-pink"}>
                        Connect
                    </button>

                    <div className={"mt-12 text-sm text-white text-center"}>Connect with the <span
                        className={'font-semibold'}>Dapper SC</span> app!
                    </div>
                </div>
                }
                {isConnected && !!!isAccountInitStateLoading && !!!isAccountInitialized && (flowBalance < 0.1) &&
                    <div className={'flex flex-col max-w-lg items-center'}>
                        <div className={"mt-12 text-sm text-white text-center"}>
                            <h1 className={'text-2xl font-semibold mb-2'}>Fund Dapper SC</h1>
                            <p>Before playing Flow Rider, your Dapper SC wallet needs to be funded with Flow. <span
                                className={'text-gray-400'}>Note, this will only be required for internal testing on TestNet</span>
                            </p>
                        </div>
                        <div className={'text-white text-center text-sm items-center'}>
                            <div className={'mt-8'}><span className={'font-semibold'}>Step 1:</span> Copy your Dapper
                                SC wallet address.
                            </div>
                            <button onClick={doCopy}
                                    className={"flex mx-auto px-4 py-1 my-2 border-2 border-gray-700 hover:border-white rounded-md text-white text-lg bg-fr-pink items-center"}>
                                <ClipboardDocumentIcon className={'h-6 mr-2'}/> Copy Address
                            </button>
                            {copied && <div className={'text-xs'}>Address copied to clipboard</div>}
                            <div className={'mt-8'}><span className={'font-semibold'}>Step 2:</span> Go to Faucet, paste
                                your address and click<br/>"Fund Your Account".
                            </div>
                            <div className={'flex flex-row'}>
                                <a href={'https://testnet-faucet.onflow.org/fund-account'} target={'_blank'}
                                   rel={'noreferrer'}
                                   className={"flex mx-auto px-4 py-1 my-2 border-2 border-gray-700 hover:border-white rounded-md text-white text-lg bg-fr-pink items-center"}>
                                    <img src={faucetIcon} className={'w-6 mr-2'} alt={''}/> Go To Faucet
                                </a>
                            </div>
                            <div className={'mt-8'}><span className={'font-semibold'}>Step 3:</span> Refresh this page
                                after account is funded.
                            </div>
                        </div>
                    </div>
                }

                {isConnected && !!!isAccountInitStateLoading && !!!isAccountInitialized && (flowBalance > 0.1) &&
                    <div className={'flex flex-col max-w-xl items-center'}>
                        <button onClick={doInitialize}
                                className={"font-pinwy text-3xl uppercase flex px-4 py-2 my-2 border-4 border-gray-700 hover:border-white rounded-md text-white bg-fr-pink"}>
                            Initialize
                        </button>

                        <div className={"mt-12 text-sm text-white text-center"}>
                            <p>Please initialize your account to play Flow Rider.<br/>After pressing Initialize, confirm the transaction in your Dapper SC app</p>
                        </div>
                    </div>
                }
                {((isConnected && isAccountInitialized) || unityUnloading) && props.children}
            </div>
        </div>
    )
}
